/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import { withRouter } from 'react-router-dom'
import qs from 'query-string'

import {
  Heading
} from '../components'

class RedirectNotice extends React.PureComponent {
  render() {
    let externalLink = qs.parse(this.props.location.search).url
    return (
      <div className='stage-main slds-p-around_xx-large'>
        <Heading>
          Redirect notice
        </Heading>
        {/* NOTE: if user chooses to proceed should redirect page location be removed from browser history so that a back from that page will return you to the PicsaOS containing the original external link */}
        You have clicked on a link that will cause you to leave PicsaOS and go to <a href={externalLink}>{externalLink}</a>.
        <br />
        If you don’t want to leave PicsaOS and visit that page, you can <a onClick={() => this.props.history.goBack()}>return to the previous page</a>.
      </div>
    )
  }
}

export default withRouter(RedirectNotice)



// WEBPACK FOOTER //
// ./src/containers/RedirectNotice.js